import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { editBeneficiaryNotes } from 'actions/beneficiaryForm'
import BeneficiaryCommentForm from 'views/Beneficiaries/BeneficiaryCommentForm'
import { getEmployeeId } from 'utils/getEmployeeId'
import { commonFunctions } from 'utils/CommonFunctions'

class BeneficiaryComment extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object,
    hide: PropTypes.func,
    id: PropTypes.string,
    modals: PropTypes.object,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    hide: null,
    forms: null,
    modals: null,
    selectedPartner: null,
  }
  static defaultProps = {
    id: 'beneficiaryComment',
  }

  _submit = (data) => {
    const formData = {
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      year: this.props.beneficiaries.currentFy.current.year,
      loginname: '', // loginname is stored on the webapi server session
      comments: (data.comments ? commonFunctions.iff(data.previousComments, `${data.comments}|${data.previousComments}`, data.comments) : ''),
    }

    this.props.dispatch(editBeneficiaryNotes(formData, this.props.id))
  }

  render() {
    const {
      modals, hide, forms, id, beneficiaries,
    } = this.props

    return (
      <BeneficiaryCommentForm
        beneficiaries={beneficiaries}
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        key={beneficiaries.fetched}
        label="Add a note"
        modals={modals}
        title="Admin notes"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  beneficiaries: state.beneficiaries,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BeneficiaryComment))



// WEBPACK FOOTER //
// ./src/containers/BeneficiaryComment.js